(function () {
  function initCompareScroll(region) {
    var step = parseInt(region.getAttribute('data-scroll-step'), 10) || 160;

    region.addEventListener('keydown', function (event) {
      if (region.scrollWidth <= region.clientWidth) return;
      if (event.key !== 'ArrowRight' && event.key !== 'ArrowLeft') return;

      event.preventDefault();
      region.scrollBy({
        left: event.key === 'ArrowRight' ? step : -step,
        behavior: 'smooth',
      });
    });
  }

  function initCompareTabs() {
    var tabNav = document.querySelector('#product-detail-tabs .nav-tab-item');
    if (!tabNav) return;

    document.querySelectorAll('#product-detail-tabs .nav-tab-item').forEach(function (tab) {
      tab.addEventListener('click', function () {
        var compareSection = document.querySelector('.product-compare');
        if (!compareSection) return;

        var firstTab = document.querySelector('#product-detail-tabs .nav-tab-item:first-child');
        if (firstTab && firstTab.classList.contains('active')) {
          compareSection.style.display = 'none';
        } else {
          compareSection.style.display = 'block';
        }
      });
    });
  }

  function initAll() {
    document.querySelectorAll('.product-compare-scroll[data-scroll-step]').forEach(initCompareScroll);
    initCompareTabs();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initAll);
  } else {
    initAll();
  }

  document.addEventListener('shopify:section:load', function (event) {
    event.target.querySelectorAll('.product-compare-scroll[data-scroll-step]').forEach(initCompareScroll);
  });
})();
